import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '../stores/userStore.js'
import { useUnsavedChangesStore } from '../stores/unsavedChangesStore.js'
import memberRoutes from './routes/member.js'
import staffRoutes from './routes/staff.js'
import publicRoutes from './routes/public.js'
import { chunkLoadErrorMessages } from '../utils/errors'

const routes = [...memberRoutes, ...staffRoutes, ...publicRoutes]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach(async (to, _from) => {
  const unsavedChangesStore = useUnsavedChangesStore()
  const userStore = useUserStore()

  if (unsavedChangesStore.hasUnsavedChanges) {
    unsavedChangesStore.setPendingNavigation({ to })
    return false
  }

  if (to.meta.must_authenticate) {
    await userStore.checkAuthenticationStatus()
    if (!userStore.isAuthenticated) {
      return { name: 'welcome' }
    }
  }

  if (to.meta.permissions_needed) {
    if (!userStore.userHasOneOrMoreOfPermissions(to.meta.permissions_needed)) {
      return '/404'
    }
  }

  document.title = `${to.meta.title} | ${import.meta.env.VITE_APP_NAME}`

  return true
})

router.onError((error, to) => {
  const isChunkLoadError = chunkLoadErrorMessages.some((message) =>
    error.message.includes(message)
  )

  if (isChunkLoadError) {
    window.location.href = to.fullPath
  }
})

// Catches preload failures (e.g. CSS) that bypass the router — Vite emits
// this event when a stale chunk fails to load after a deploy.
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

export default router
